import createAnalytics from '~coreModules/analytics/js/analytics-store';

export { ANALYTICS_MODULE_NAME } from '~coreModules/analytics/js/analytics-store';

export default function createCommonAnalytics(config) {
    return {
        ...createAnalytics(config),
    };
}
